const shanxinApp = [
    //-------------------引流落地页--------------------------------------
    //落地页第一版   暂停使用
    // {
    //   path: '/landPage1',
    //   component: () => import('@/pages/attractTraffic/landPage1.vue'),
    //   meta: {
    //     title: '智借',
    //     keepAlive: false
    //   }
    // },
    //落地页第二版
    {
      path: '/landPage2',
      component: () => import('@/pages/attractTraffic/landPage2.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },


    //落地页第三版  深蓝色版本    
    {
      path: '/landPage1',//landpage3 替换landPage1的域名
      component: () => import('@/pages/attractTraffic/landPage3.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },
    {
      path: '/landPage3',
      component: () => import('@/pages/attractTraffic/landPage3.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },

    //短链落地页版
    {
      path: '/p',
      component: () => import('@/pages/attractTraffic/landPage3.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },
    //短链 短信召回页
    {
      path: '/d',
      component: () => import('@/pages/attractTraffic/only-download.vue'),
      meta: {
        title: '智借',
        keepAlive: false
      }
    },
    {
      path: '/attractTraffic/attractTraffic-detail',
      component: () => import('@/pages/attractTraffic/only-download.vue'),
      meta: {
        title: '详情',
        keepAlive: false
      }
    },

    //新版本下载页 里面是手机样式+橘黄色按钮
    {
      path: '/attractTraffic/only-download',
      component: () => import('@/pages/attractTraffic/only-download.vue'),
      meta: {
        title: '详情',
        keepAlive: false
      }
    },
    
    // //百信下载页 ---闪信版本
    {
      path: '/attractTraffic/shanxin-download',
      component: () => import('@/pages/attractTraffic/shanxin-download.vue'),
      meta: {
        title: '详情',
        keepAlive: false
      }
    },

    //速贷联合登录
    {
      path: '/attractTraffic/sudai',
      component: () => import('@/pages/attractTraffic/sudai.vue'),
      meta: {
        title: '协议'
      }
    },



    //第三方落地页  定制
    {
      path: '/attractTraffic/third-download',
      component: () => import('@/pages/attractTraffic/third-download'),
      meta: {
        title: '下载页',
        keepAlive: false
      }
    },

    //联登速贷产品详情
    {
      path: '/attractTraffic/sudai-product-detail',
      component: () => import('@/pages/attractTraffic/sudai-product-detail'),
      meta: {
        title: '加载中',
        keepAlive: false
      }
    },
  ]
  export default shanxinApp
  


// WEBPACK FOOTER //
// ./src/router/modules/attract-traffic.js